import React from 'react';

import NotFoundContainer from './components/NotFoundContainer';

const NotFoundPage = () => {
  return (
    <NotFoundContainer
      link="/"
      title={{ id: '404.header', defaultMessage: 'Page not found' }}
      description={{ id: '404.description', defaultMessage: 'The page you are looking for does not exist' }}
      buttonText={{ id: '404.backButton', defaultMessage: 'Back to homepage' }}
    />
  );
};

export default NotFoundPage;
